import { Popup } from './popup'

export class Popups {
    constructor(arr) {
        this.popupsArr = [];
        this.popups = Object.keys(arr)
        this.init(arr);
    }
    init(arr) {        
        for (let i = 0; i < this.popups.length; i++) {
            let p_id = this.popups[i]
            this.popupsArr.push(new Popup(arr[p_id], p_id))
        }
    }
    resize(){
        for (let i = 0; i < this.popupsArr.length; i++) {
            if (this.popupsArr[i].popupOpen){
                this.popupsArr[i].setHeight();
            }
        }    
    }
}

